import baseline from './app-baseline.json';
import type { AppearanceConfig } from './appearance';
import type { AppScreens } from '../screenBuilder/model';
import type { PresentationSnapshot } from './PresentationContext';

// Updated only by a reviewed baseline promotion; every app release keeps its own copy.
export const bundledBaseline = baseline as {
  version: 1; revision: string; sourceHash: string | null; approvalId?: number;
  appearanceLayers?: AppearanceConfig[]; appearance: AppearanceConfig | null; screens: AppScreens | null;
};
export const bundledPresentation = (): PresentationSnapshot => ({
  version: 1, appearance: null, screens: bundledBaseline.screens,
});
